import 'styles/templates/team.scss'

import 'scripts/vue/main'

import Vue from 'vue'
import VModal from 'vue-js-modal'

Vue.use(VModal)

window.PSTheme.Vue.Team = new Vue({
  name: 'TeamWrapper',
  components: {
    'team': require('../vue/templates/Team.vue').default
  }
}).$mount('.team')
